// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__qMR79","col":"styles_col__1FIUr"};